import React from 'react';
import { ArrowUpRight } from 'lucide-react';

const IntroSection = () => {
  return (
    <section className="section" style={{ background: '#FFFFFF' }}>
      <div className="container-x grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <div className="lg:col-span-6">
          <p className="text-xs md:text-sm uppercase tracking-[0.25em] font-medium text-[#12367F]/60 mb-6">
            360° Social Agency
          </p>
          <h2
            className="font-display uppercase text-[#12367F] text-balance"
            style={{ fontSize: 'clamp(2.25rem, 5.5vw, 5rem)', lineHeight: 0.92 }}
          >
            Fuelling brand growth through{' '}
            <span style={{ background: '#2EF5FF' }} className="px-2 rounded-md">social-first</span>{' '}
            strategies that turns moments into results
          </h2>
        </div>
        <div className="lg:col-span-6 lg:pt-4 space-y-5 text-[#12367F]/85 text-base md:text-lg leading-relaxed">
          <p>
            You can’t guess your way to the top of the social ladder. That’s why we created
            Nasu Agency, a leading influencer marketing agency in London. From{' '}
            <span className="underline decoration-2 underline-offset-4 decoration-[#2EF5FF]">managing talent</span>{' '}
            and crafting game-changing creator strategies to producing scroll-stopping content,
            we’ve got every angle covered.
          </p>
          <p>
            As a specialist influencer marketing agency, we deliver end-to-end influencer campaign
            strategy, from talent sourcing and creative planning to execution and reporting. Our
            dedicated{' '}
            <span className="underline decoration-2 underline-offset-4 decoration-[#2EF5FF]">influencer talent management</span>{' '}
            team connects brands with the right creators, ensuring campaigns are authentic,
            data-driven, and designed to drive real impact across platforms like Instagram, TikTok
            and YouTube.
          </p>
          <p>
            Everything we do is designed with social at the core. The result? Audiences that
            engage, resonate, and stick around for the long haul. Just one of the many reasons
            we’re considered a standout influencer marketing agency in Both UK and USA.
          </p>
          <div className="pt-4 flex flex-wrap gap-3">
            <a href="/services" className="btn-base btn-primary">
              Explore our services <ArrowUpRight className="h-4 w-4" />
            </a>
            <a href="/contact" className="btn-base btn-outline-dark">
              Book a free strategy session <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
